/**
 * Toaster — shadcn/ui adapter for the `sonner` toast primitive.
 *
 * Lifted from the binding mockup at
 * `reignara_redesign/components/ui/sonner.tsx`. Class strings and inline
 * `style` consume design tokens via CSS variables (`var(--popover)`,
 * `var(--popover-foreground)`, `var(--border)`); no hex / `rgb(` /
 * `hsl(` literals (Requirement 4.5).
 *
 * Dark mode dropped in PR (m.0); the `theme` prop is pinned to `light`
 * since the system is light-only.
 *
 * Feature: meridian-redesign
 * Requirements: 4.3, 4.4, 4.5
 */

import * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

function Toaster({ ...props }: ToasterProps): JSX.Element {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
